import { render, staticRenderFns } from "./OptionParam.vue?vue&type=template&id=2b0705b5&scoped=true&lang=pug"
import script from "./OptionParam.vue?vue&type=script&lang=js"
export * from "./OptionParam.vue?vue&type=script&lang=js"
import style0 from "./OptionParam.vue?vue&type=style&index=0&id=2b0705b5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0705b5",
  null
  
)

export default component.exports